import { httpV1 as http } from '@/services/api';

export function fromApiPayload(payload) {
  return {
    referenceMonth: payload.reference_month,
    daysRemainingInMonth: payload.days_remaining_in_month,
    monthly: payload.monthly ? {
      products: (payload.monthly.products ?? []).map((product) => ({
        productId: product.product_id,
        productName: product.product_name,
        targetAmount: product.target_amount,
        achievedAmount: product.achieved_amount,
        pct: product.pct,
        remainingAmount: product.remaining_amount,
        tierReached: product.tier_reached,
        nextTier: product.next_tier,
        remainingToNextTier: product.remaining_to_next_tier,
      })),
      consolidated: {
        targetAmount: payload.monthly.consolidated.target_amount,
        achievedAmount: payload.monthly.consolidated.achieved_amount,
        pct: payload.monthly.consolidated.pct,
        remainingAmount: payload.monthly.consolidated.remaining_amount,
      },
    } : null,
    weekly: payload.weekly ? {
      weekStart: payload.weekly.week_start,
      daysRemainingInWeek: payload.weekly.days_remaining_in_week,
      farmer: {
        target: payload.weekly.farmer.target,
        achieved: payload.weekly.farmer.achieved,
        pct: payload.weekly.farmer.pct,
        remaining: payload.weekly.farmer.remaining,
        status: payload.weekly.farmer.status,
      },
      hunterStatus: payload.weekly.hunter_status,
    } : null,
  };
}

export async function getSummary({ commercial_id, reference_month } = {}) {
  return http
    .get('/commercial-goals/me/summary', {
      params: {
        ...(commercial_id ? { commercial_id } : {}),
        ...(reference_month ? { reference_month } : {}),
      },
    })
    .then(({ data }) => fromApiPayload(data.data));
}
